<template>
	<el-row>
		<span>图片库</span>
		<el-divider></el-divider>
		<div class="flex">
			<el-card shadow="hover" v-for="(item, index) in list" :key="index" @click.native="toTwo(item)">
				<el-image style="width: 100px;height:100px;" src="http://img.xinian727.cn/xnmall3/images/wenjian.png" />
				<div class="name">{{ item.name }}</div>
				<div class="btnBox">
					<el-button type="primary" icon="el-icon-edit" circle size="mini" @click.stop="open(item)">
					</el-button>
					<el-button type="danger" icon="el-icon-delete" circle size="mini" @click.stop="remove(item)">
					</el-button>
				</div>
			</el-card>
			<el-card shadow="hover">
				<div class="addBox" @click="open()">+</div>
			</el-card>
		</div>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
			<el-form :model="form" ref="form" :rules="rules" label-width="80px" label-position="right">
				<el-form-item label="文件名" prop="name">
					<el-input v-model="form.name" placeholder="请输入文件名"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submit">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				title: "",
				dialogVisible: false,
				parentId: 0, //默认是一级分类pid为0
				form: {
					id: "",
					name: "",
					sort: 1
				},
				rules: {
					name: [{
						required: true,
						message: "请输入文件夹名",
						trigger: "change"
					}],
				},
				list: [],
			};
		},
		created() {
			this.loadData();
			this.checkToken()
		},
		methods: {
			checkToken() {
				this.$http.get(`/api/material/auth/check`, {}).then(res => {
					console.info(res.data)
					if (!res.data) {
						window.localStorage.removeItem('token');
						this.$message.error('登录状态失效，请重新登录');
						setTimeout(() => {
							this.$router.replace('/login');
						}, 1500)
					}
				})
			},
			loadData() {
				this.$http.get(`/api/material/categories/0`, {}).then(res => {
					console.info("loadData", res)
					this.list = res.data ? res.data.children : []
				})
			},
			toTwo(item) {
				console.log(item);
				let routeData = this.$router.resolve({
					path: "/mat_class2",
					query: item,
				});
				window.open(routeData.href, '_blank');
			},
			remove(row) {
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.$http.delete('/api/material/categories/' + row.id, {}).then(res => {
						console.info("sumbit", res)
						if (res.status == 500) {
							console.info("系统异常")
						}
						if (res.status == 202) {
							console.info("存在子节点,不允许被删除")
						}
						this.loadData();
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				})
			},
			open(row) {
				console.info(row)
				this.dialogVisible = true;
				if (row) {
					this.title = "文件夹编辑";
					this.form = {
						id: row.id,
						name: row.name,
						sort: row.sort
					};
				} else {
					this.title = "文件夹创建";
					this.form = {
						id: undefined,
						name: undefined,
						sort: 1
					}
				}
			},
			submit() {
				if (this.form.id) {
					this.edit()
				} else {
					this.save()
				}
			},
			save() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.$http.post(
							'/api/material/categories/' + this.parentId + '/children', this.form
						).then(res => {
							console.info("sumbit", res)
							if (res.status == 500) {
								console.info("系统异常")
							}
							if (res.data == "请先添加父类目") {
								console.info('父类目不存在')
							} else {
								this.loadData();
							}
						})
						this.dialogVisible = false;
					}
				});
			},
			edit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.$http.put('/api/material/categories/' + this.form.id + '/name', {
							name: this.form.name
						}).then(res => {
							console.info("sumbit", res)
							if (res.status == 500) {
								console.info("系统异常")
							}
							if (res.data == "请先添加父类目") {
								console.info('父类目不存在')
							} else {
								this.loadData();
							}
						})
						this.dialogVisible = false;
					}
				});
			},
		},
	};
</script>

<style scoped>
	::v-deep .el-card__body {
		padding: 0;
	}

	::v-deep .el-card {
		width: 100px;
		height: 160px;
		margin: 10px;
	}

	.btnBox {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.flex {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	.addBox {
		font-size: 24px;
		height: 160px;
		line-height: 160px;
		text-align: center;
	}

	.name {
		width: 100%;
		text-align: center;
		margin: -10px auto 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap
	}
</style>
